import { render, staticRenderFns } from "./batchEdit.vue?vue&type=template&id=5224b182&scoped=true&lang=html&"
import script from "./batchEdit.vue?vue&type=script&lang=js&"
export * from "./batchEdit.vue?vue&type=script&lang=js&"
import style0 from "./batchEdit.vue?vue&type=style&index=0&id=5224b182&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5224b182",
  null
  
)

export default component.exports